<div class="modal flex-wrap justify-center align-center">
  <div class="modal__wrap" [style]="{ 'max-width': modalWidth }">
    <header class="modal__header flex justify-between">
      <h4>{{ modalTitle }}</h4>

      <img src="assets/images/close.svg" alt="x" (click)="handleClose()"/>
    </header>
    <article class="modal__content">
      <ng-content></ng-content>
    </article>
  </div>
</div>
